import axios from 'axios';
// Application Host Main Url
//export const mainUrl = 'http://localhost:8080/';
//export const mainUrl = 'https://localhost:8443/';
export const mainUrl = 'https://qrspno.com:8443/';

export const TABLE_NAME_SELECTED = 'TABLE_NAME_SELECTED';

// Axios client
export const client = axios.create({
    headers: {
        "Content-Type": "application/JSON",
        "X-CSRF-TOKEN": "NO-TOKEN",
        "Authorization": "p2%Mt*!98bWqLOIX",
    }
});
// Default object for ADD
export const defaultPianoTechUser = {
    userId: 0,
    loginId: "",
    encryptedPassword: "",
    userName: "",
    userEmail: "",
    adminUser: false,
    requireNewPassword: false,
    lockedOut: false,
    currentInvalidLoginAttempts: 0,
    lifetimeInvalidLoginAttempts: 0,
    lastLoginIpAddress: "",
    lastLogin: "",
    lastInvalidLogin: "",
    created: "",
    lastUpdated: "",
    companyId: "0",
}

export const defaultPianoTechCompany = {
    companyId: "0",
    companyName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    encryptedPhone: "",
    encryptedTaxId: "",
    defaultMinutesPerAppointment: 0,
    defaultBeforeAppointmentMinutes: 0,
    defaultAfterAppointmentMinutes: 0,
    created: "",
    lastUpdated: "",
}

export const defaultPianoTechnician = {
    techniciansId: 0,
    companyId: 0,
    technicianName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    email: "",
    encryptedPhone: "",
    encryptedTaxId: "",
    defaultMinutesPerAppointment: -1,
    defaultBeforeAppointmentMinutes: -1,
    defaultAfterAppointmentMinutes: -1,
    onlyScheduleWithinNormalScheduled: false,
    mondayStartTime: "0800",
    mondayStopTime: "1700",
    tuesdayStartTime: "0800",
    tuesdayStopTime: "1700",
    wednesdayStartTime: "0800",
    wednesdayStopTime: "1700",
    thursdayStartTime: "0800",
    thursdayStopTime: "1700",
    fridayStartTime: "0800",
    fridayStopTime: "1700",
    saturdayStartTime: "0000",
    saturdayStopTime: "0000",
    sundayStartTime: "0000",
    sundayStopTime: "0000",
    created: "",
    lastUpdated: "",
    utcHoursAdjustment: "0",
}

export const defaultPianoTechCustomer = {
    customerId: 0,
    companyId: 0,
    customerName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    email: "",
    encryptedPhone: "",
    textOptOut: false,
    emailOptOut: false,
    notes: "",
    defaultBeforeAppointmentMinutes: -1,
    defaultAfterAppointmentMinutes: -1,
    created: "",
    lastUpdated: "",
    utcHoursAdjustment: "0",
}

export const defaultPianoTechPiano = {
    pianoId: 0,
    companyId: 0,
    customerId: 0,
    deviceType: "",
    year: "",
    make: "",
    model: "",
    serialNumber: "",
    nickname: "",
    defaultMinutesPerAppointment: 0,
    notes: "",
    created: "",
    lastUpdated: "",
    lastPianoTune: "",
    normalMonthsBetweenTunnings: "6",
}

export const defaultPianoTechAppointment = {
    appointmentId: 0,
    companyId: 0,
    customerId: 0,
    techniciansId: 0,
    pianoId: 0,
    tuning: true,
    serviceReason: "Tuning",
    notes: "",
    notificationTimestamp1: "",
    notificationTimestamp2: "",
    notificationTimestamp3: "",
    customerConfirmedTimestamp: "",
    customerCancelledTimestamp: "",
    appointmentTimeStart: "",
    minutesRequired: 0,
    appointmentTimeEnd: "",
    blockStartTime: "",
    blockEndTime: "",
    created: "",
    lastUpdated: "",
    minutesBefore: "0",
    minutesAfter: "0",
}

// create list of time zone to select with number of minutes from UTC
export const timeZones = [
    {
        "description": "UTC-12:00 Baker Island",
        "minutesFromUTC": "-720"
    },
    {
        "description": "UTC-11:00 Niue, Samoa",
        "minutesFromUTC": "-660"
    },
    {
        "description": "UTC-10:00 Hawaii-Aleutian Standard Time",
        "minutesFromUTC": "-600"
    },
    {
        "description": "UTC-09:00 Alaska Standard Time",
        "minutesFromUTC": "-540"
    },
    {
        "description": "UTC-08:00 Pacific Standard Time",
        "minutesFromUTC": "-480"
    },
    {
        "description": "UTC-07:00 Mountain Standard Time",
        "minutesFromUTC": "-420"
    },
    {
        "description": "UTC-06:00 Central Standard Time",
        "minutesFromUTC": "-360"
    },
    {
        "description": "UTC-05:00 Eastern Standard Time",
        "minutesFromUTC": "-300"
    },
    {
        "description": "UTC-04:00 Atlantic Standard Time",
        "minutesFromUTC": "-240"
    },
    {
        "description": "UTC-03:00 Argentina, Brazil, Uruguay",
        "minutesFromUTC": "-180"
    },
    {
        "description": "UTC-02:00 South Georgia/Sandwich Is.",
        "minutesFromUTC": "-120"
    },
    {
        "description": "UTC-01:00 Azores",
        "minutesFromUTC": "-60"
    },
    {
        "description": "UTC+00:00 Greenwich Mean Time",
        "minutesFromUTC": "0"
    },
    {
        "description": "UTC+01:00 Central European Time",
        "minutesFromUTC": "60"
    },
    {
        "description": "UTC+02:00 Eastern European Time",
        "minutesFromUTC": "120"
    },
    {
        "description": "UTC+03:00 Moscow, East Africa",
        "minutesFromUTC": "180"
    },
    {
        "description": "UTC+04:00 Gulf Standard Time",
        "minutesFromUTC": "240"
    },
    {
        "description": "UTC+05:00 Pakistan Standard Time",
        "minutesFromUTC": "300"
    },
    {
        "description": "UTC+05:30 India Standard Time",
        "minutesFromUTC": "330"
    },
    {
        "description": "UTC+06:00 Bangladesh Standard Time",
        "minutesFromUTC": "360"
    },
    {
        "description": "UTC+06:30 Cocos Islands, Myanmar",
        "minutesFromUTC": "390"
    },
    {
        "description": "UTC+07:00 Indochina Time",
        "minutesFromUTC": "420"
    },
    {
        "description": "UTC+08:00 China, Singapore",
        "minutesFromUTC": "480"
    },
    {
        "description": "UTC+09:00 Japan Standard Time",
        "minutesFromUTC": "540"
    },
    {
        "description": "UTC+10:00 Australian Eastern Standard Time",
        "minutesFromUTC": "600"
    },
    {
        "description": "UTC+11:00 Solomon Islands, New Caledonia",
        "minutesFromUTC": "660"
    },
    {
        "description": "UTC+12:00 Fiji, Kamchatka, Marshall Is.",
        "minutesFromUTC": "720"
    }
]

// set defaultTravelTimes up to 120 minutes
export const defaultTravelTimes = [
    {
        "description": "No Travel Time",
        "minutes": "0"
    },
    {
        "description": "15 minutes",
        "minutes": "15"
    },
    {
        "description": "30 minutes",
        "minutes": "30"
    },
    {
        "description": "45 minutes",
        "minutes": "45"
    },
    {
        "description": "60 minutes",
        "minutes": "60"
    },
    {
        "description": "75 minutes",
        "minutes": "75"
    },
    {
        "description": "90 minutes",
        "minutes": "90"
    },
    {
        "description": "105 minutes",
        "minutes": "105"
    },
    {
        "description": "120 minutes",
        "minutes": "120"
    }
]

// set defaultAppointmentTimes up to 240 minutes
export const defaultAppointmentTimes = [
    {
        "description": "15 minutes",
        "minutes": "15"
    },
    {
        "description": "30 minutes",
        "minutes": "30"
    },
    {
        "description": "45 minutes",
        "minutes": "45"
    },
    {
        "description": "60 minutes",
        "minutes": "60"
    },
    {
        "description": "75 minutes",
        "minutes": "75"
    },
    {
        "description": "90 minutes",
        "minutes": "90"
    },
    {
        "description": "105 minutes",
        "minutes": "105"
    },
    {
        "description": "120 minutes",
        "minutes": "120"
    },
    {
        "description": "135 minutes",
        "minutes": "135"
    },
    {
        "description": "150 minutes",
        "minutes": "150"
    },
    {
        "description": "165 minutes",
        "minutes": "165"
    },
    {
        "description": "180 minutes",
        "minutes": "180"
    },
    {
        "description": "195 minutes",
        "minutes": "195"
    },
    {
        "description": "210 minutes",
        "minutes": "210"
    },
    {
        "description": "225 minutes",
        "minutes": "225"
    },
    {
        "description": "240 minutes",
        "minutes": "240"
    }
]


// Maintenance Types
export const MAINTENANCE_TYPE_VIEW = 'view'
export const MAINTENANCE_TYPE_EDIT = 'edit'
export const MAINTENANCE_TYPE_ADD = 'add'
export const MAINTENANCE_TYPE_DELETE = 'delete'
export const MAINTENANCE_TYPE_COMPLETE = 'complete'
// Message Types
export const MESSAGE_TYPE_INFO = 'info'
export const MESSAGE_TYPE_CONFIRM = 'confirm'
export const MESSAGE_TYPE_ERROR = 'error'
// Views
export const VIEW_PIANOTECHUSER_LIST = 'listPianoTechUser'
export const VIEW_PIANOTECHUSER_UPDATE = 'updatePianoTechUser'
export const VIEW_PIANOTECHCOMPANY_LIST = 'listPianoTechCompany'
export const VIEW_PIANOTECHCOMPANY_UPDATE = 'updatePianoTechCompany'
export const VIEW_PIANOTECHNICIAN_LIST = 'listPianoTechnician'
export const VIEW_PIANOTECHNICIAN_UPDATE = 'updatePianoTechnician'
export const VIEW_PIANOTECHCUSTOMER_LIST = 'listPianoTechCustomer'
export const VIEW_PIANOTECHCUSTOMER_UPDATE = 'updatePianoTechCustomer'
export const VIEW_PIANOTECHPIANO_LIST = 'listPianoTechPiano'
export const VIEW_PIANOTECHPIANO_UPDATE = 'updatePianoTechPiano'
export const VIEW_PIANOTECHAPPOINTMENT_LIST = 'listPianoTechAppointment'
export const VIEW_PIANOTECHAPPOINTMENT_UPDATE = 'updatePianoTechAppointment'
export const PIANOTECHUSER_TABLE = 'PianoTechUser'
export const PIANOTECHCOMPANY_TABLE = 'PianoTechCompany'
export const PIANOTECHNICIAN_TABLE = 'PianoTechnician'
export const PIANOTECHCUSTOMER_TABLE = 'PianoTechCustomer'
export const PIANOTECHPIANO_TABLE = 'PianoTechPiano'
export const PIANOTECHAPPOINTMENT_TABLE = 'PianoTechAppointment'
// UI Field Information
export const uiFieldInfoPianoTechUser = [
    {
        "fieldName": "userId",
        "displayTitle": "User Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "false",
        "updatable": "false",
    },
    {
        "fieldName": "loginId",
        "displayTitle": "Login Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "80",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "encryptedPassword",
        "displayTitle": "Encrypted Password",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "256",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "userName",
        "displayTitle": "User Name",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "userEmail",
        "displayTitle": "User Email",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "adminUser",
        "displayTitle": "Admin User",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "requireNewPassword",
        "displayTitle": "Require New Password",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lockedOut",
        "displayTitle": "Locked Out",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "currentInvalidLoginAttempts",
        "displayTitle": "Current Invalid Login Attempts",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lifetimeInvalidLoginAttempts",
        "displayTitle": "Lifetime Invalid Login Attempts",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastLoginIpAddress",
        "displayTitle": "Last Login Ip Address",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "50",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastLogin",
        "displayTitle": "Last Login",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastInvalidLogin",
        "displayTitle": "Last Invalid Login",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "created",
        "displayTitle": "Created",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastUpdated",
        "displayTitle": "Last Updated",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "companyId",
        "displayTitle": "Company Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
];

export const uiFieldInfoPianoTechCompany = [
    {
        "fieldName": "companyId",
        "displayTitle": "Company Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "false",
        "updatable": "false",
    },
    {
        "fieldName": "companyName",
        "displayTitle": "Company Name",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "80",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "addressLine1",
        "displayTitle": "AddressLine1",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "addressLine2",
        "displayTitle": "AddressLine2",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "city",
        "displayTitle": "City",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "state",
        "displayTitle": "State",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "20",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "country",
        "displayTitle": "Country",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "50",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "encryptedPhone",
        "displayTitle": "Encrypted Phone",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "encryptedTaxId",
        "displayTitle": "Encrypted Tax Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultMinutesPerAppointment",
        "displayTitle": "Default Minutes Per Appointment",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "3",
        "decimalPositions": "0",
        "minimumValue": "0",
        "maximumValue": "480",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultBeforeAppointmentMinutes",
        "displayTitle": "DefaultBeforeAppointmentMinutes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "0",
        "maximumValue": "120",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultAfterAppointmentMinutes",
        "displayTitle": "DefaultAfterAppointmentMinutes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "0",
        "maximumValue": "120",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "created",
        "displayTitle": "Created",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastUpdated",
        "displayTitle": "Last Updated",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
];

export const uiFieldInfoPianoTechnician = [
    {
        "fieldName": "techniciansId",
        "displayTitle": "Technicians Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "false",
        "updatable": "false",
    },
    {
        "fieldName": "companyId",
        "displayTitle": "Company Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "technicianName",
        "displayTitle": "Technician Name",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "80",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "addressLine1",
        "displayTitle": "AddressLine1",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "addressLine2",
        "displayTitle": "AddressLine2",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "city",
        "displayTitle": "City",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "state",
        "displayTitle": "State",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "20",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "country",
        "displayTitle": "Country",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "50",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "email",
        "displayTitle": "Email",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "encryptedPhone",
        "displayTitle": "Encrypted Phone",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "encryptedTaxId",
        "displayTitle": "Encrypted Tax Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultMinutesPerAppointment",
        "displayTitle": "Default Minutes Per Appointment",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "-1",
        "maximumValue": "480",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultBeforeAppointmentMinutes",
        "displayTitle": "DefaultBeforeAppointmentMinutes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "-1",
        "maximumValue": "120",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultAfterAppointmentMinutes",
        "displayTitle": "DefaultAfterAppointmentMinutes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "-1",
        "maximumValue": "120",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "onlyScheduleWithinNormalScheduled",
        "displayTitle": "OnlyScheduleWithinNormalScheduled",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "mondayStartTime",
        "displayTitle": "MondayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "mondayEndTime",
        "displayTitle": "MondayEndTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "tuesdayStartTime",
        "displayTitle": "TuesdayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "tuesdayEndTime",
        "displayTitle": "TuesdayEndTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "wednesdayStartTime",
        "displayTitle": "WednesdayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "wednesdayStopTime",
        "displayTitle": "WednesdayStopTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "thursdayStartTime",
        "displayTitle": "ThursdayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "thursdayStopTime",
        "displayTitle": "ThursdayStopTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "fridayStartTime",
        "displayTitle": "FridayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "fridayStopTime",
        "displayTitle": "FridayStopTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "saturdayStartTime",
        "displayTitle": "SaturdayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "saturdayStopTime",
        "displayTitle": "SaturdayStopTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "sundayStartTime",
        "displayTitle": "SundayStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "sundayStopTime",
        "displayTitle": "SundayStopTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "4",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "created",
        "displayTitle": "Created",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastUpdated",
        "displayTitle": "Last Updated",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "utcHoursAdjustment",
        "displayTitle": "UTC Hours Adjustment",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "3",
        "decimalPositions": "0",
        "minimumValue": "-720",
        "maximumValue": "720",
        "showOnAdd": "true",
        "updatable": "true"
    }
];

export const uiFieldInfoPianoTechCustomer = [
    {
        "fieldName": "customerId",
        "displayTitle": "Customer Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "false",
        "updatable": "false",
    },
    {
        "fieldName": "companyId",
        "displayTitle": "Company Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "customerName",
        "displayTitle": "Customer Name",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "80",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "addressLine1",
        "displayTitle": "AddressLine1",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "addressLine2",
        "displayTitle": "AddressLine2",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "city",
        "displayTitle": "City",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "state",
        "displayTitle": "State",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "20",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "country",
        "displayTitle": "Country",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "50",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "email",
        "displayTitle": "Email",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "encryptedPhone",
        "displayTitle": "Encrypted Phone",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "textOptOut",
        "displayTitle": "TextOptOut",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "emailOptOut",
        "displayTitle": "EmailOptOut",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "notes",
        "displayTitle": "Notes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "1000",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultBeforeAppointmentMinutes",
        "displayTitle": "DefaultBeforeAppointmentMinutes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "-1",
        "maximumValue": "120",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultAfterAppointmentMinutes",
        "displayTitle": "DefaultAfterAppointmentMinutes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "-1",
        "maximumValue": "120",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "created",
        "displayTitle": "Created",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastUpdated",
        "displayTitle": "Last Updated",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "utcHoursAdjustment",
        "displayTitle": "UTC Hours Adjustment",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "3",
        "decimalPositions": "0",
        "minimumValue": "-720",
        "maximumValue": "720",
        "showOnAdd": "true",
        "updatable": "true"
    }
];

export const uiFieldInfoPianoTechPiano = [
    {
        "fieldName": "pianoId",
        "displayTitle": "Piano Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "false",
        "updatable": "false",
    },
    {
        "fieldName": "companyId",
        "displayTitle": "Company Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "customerId",
        "displayTitle": "Customer Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "deviceType",
        "displayTitle": "Device Type",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "50",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "year",
        "displayTitle": "Year",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "20",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "make",
        "displayTitle": "Make",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "model",
        "displayTitle": "Model",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "serialNumber",
        "displayTitle": "SerialNumber",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "nickname",
        "displayTitle": "Nickname",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "defaultMinutesPerAppointment",
        "displayTitle": "DefaultMinutesPerAppointment",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "notes",
        "displayTitle": "Notes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "5000",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "created",
        "displayTitle": "Created",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastUpdated",
        "displayTitle": "Last Updated",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastPianoTune",
        "displayTitle": "Last Piano Tune",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "normalMonthsBetweenTunnings",
        "displayTitle": "Normal Months Between Tunnings",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "0",
        "maximumValue": "999",
        "showOnAdd": "true",
        "updatable": "true",
    },
];

export const uiFieldInfoPianoTechAppointment = [
    {
        "fieldName": "appointmentId",
        "displayTitle": "Appointment Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "false",
        "updatable": "false",
    },
    {
        "fieldName": "companyId",
        "displayTitle": "Company Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "customerId",
        "displayTitle": "Customer Id",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "techniciansId",
        "displayTitle": "Technicians Id",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "pianoId",
        "displayTitle": "Piano Id",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "tuning",
        "displayTitle": "Tuning",
        "required": "false",
        "fieldType": "checkbox",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "serviceReason",
        "displayTitle": "ServiceReason",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "100",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "notes",
        "displayTitle": "Notes",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "1000",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "notificationTimestamp1",
        "displayTitle": "NotificationTimestamp1",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "notificationTimestamp2",
        "displayTitle": "NotificationTimestamp2",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "notificationTimestamp3",
        "displayTitle": "NotificationTimestamp3",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "customerConfirmedTimestamp",
        "displayTitle": "CustomerConfirmedTimestamp",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "customerCancelledTimestamp",
        "displayTitle": "CustomerCancelledTimestamp",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "appointmentTimeStart",
        "displayTitle": "AppointmentTimeStart",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "minutesRequired",
        "displayTitle": "MinutesRequired",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "1",
        "maximumValue": "480",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "appointmentTimeEnd",
        "displayTitle": "AppointmentTimeEnd",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "blockStartTime",
        "displayTitle": "BlockStartTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "blockEndTime",
        "displayTitle": "BlockEndTime",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "created",
        "displayTitle": "Created",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "lastUpdated",
        "displayTitle": "Last Updated",
        "required": "false",
        "fieldType": "textinput",
        "editType": "NoValidation",
        "maxLength": "0",
        "decimalPositions": "0",
        "minimumValue": "",
        "maximumValue": "",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "minutesBefore",
        "displayTitle": "MinutesBefore",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "0",
        "maximumValue": "99",
        "showOnAdd": "true",
        "updatable": "true",
    },
    {
        "fieldName": "minutesAfter",
        "displayTitle": "MinutesAfter",
        "required": "true",
        "fieldType": "textinput",
        "editType": "NumericOnly",
        "maxLength": "10",
        "decimalPositions": "0",
        "minimumValue": "0",
        "maximumValue": "99",
        "showOnAdd": "true",
        "updatable": "true",
    },

];

